import { ZURICH, dayKey } from "../wind/time.ts";

export interface HourParts {
  /** "13" / "14": the hour the sum starts and ends, Zurich time. */
  from: string;
  to: string;
  /** Short weekday, only when the hour is not on the same Zurich day as `nowMs`. */
  day: string;
}

/** The hour [H, H+1) in Zurich time, for the label "13–14". */
export function hourParts(fromMs: number, nowMs: number, locale: string): HourParts {
  const hh = (ms: number) =>
    new Intl.DateTimeFormat(locale, { timeZone: ZURICH, hour: "2-digit", hourCycle: "h23" })
      .formatToParts(new Date(ms))
      .find((p) => p.type === "hour")!.value;
  const day =
    dayKey(fromMs) === dayKey(nowMs)
      ? ""
      : new Intl.DateTimeFormat(locale, { timeZone: ZURICH, weekday: "short" })
          .format(new Date(fromMs))
          .replace(/\.$/, "");
  return { from: hh(fromMs), to: hh(fromMs + 3_600_000), day };
}

/** Compact slider label: "13–14", "Do 13–14" on another day. */
export function formatHourLabel(fromMs: number, nowMs: number, locale: string): string {
  const p = hourParts(fromMs, nowMs, locale);
  return `${p.day ? `${p.day} ` : ""}${p.from}–${p.to}`;
}

/** The start of the hour containing `tMs`. */
export const hourStart = (tMs: number): number => Math.floor(tMs / 3_600_000) * 3_600_000;
